import React from "react"
import {
  IconClover,
  IconFlag,
  IconBook,
  IconBooks,
  IconMusic,
  IconMicrophone,
  IconVideo,
  IconDeviceGamepad2,
  IconSchool,
  IconLanguage,
  IconMap,
  IconMapPin,
  IconHeart,
  IconStar,
  IconUsers,
  IconCalendarEvent,
  IconNews,
  IconPencil,
  IconBrush,
  IconCamera,
  IconMountain,
  IconTree,
  IconSun,
  IconMoon,
  IconCloud,
  IconDroplet,
  IconFlame,
  IconLeaf,
  IconPlant,
  IconCrown,
  IconShield,
  IconSword,
  IconWand,
  IconGhost,
  IconSkull,
  IconDiamond,
  IconCoins,
  IconTrophy,
  IconMedal,
  IconRocket,
  IconPlanet,
  IconAtom,
  IconDna,
  IconFlask,
  IconMicroscope,
  IconStethoscope,
  IconPill,
  IconApple,
  IconCoffee,
  IconBeer,
  IconGlass,
  IconChefHat,
  IconGrill,
  IconCar,
  IconBike,
  IconPlane,
  IconShip,
  IconTrain,
  IconBus,
  IconHome,
  IconBuilding,
  IconTower,
  IconBuildingBank,
  IconBuildingBridge,
  IconBuildingLighthouse,
  IconAnchor,
  IconCompass,
  IconWorld,
  IconGlobe,
  IconBrandApple,
  IconBrandAndroid,
  IconBrandSpotify,
  IconBrandYoutube,
  IconHeadphones,
  IconVinyl,
  IconPiano,
  IconMessage,
  IconMessages,
  IconMail,
  IconBell,
  IconBulb,
  IconQuestionMark,
  IconInfoCircle,
  IconAlertCircle,
  IconCircleCheck,
  IconCircleX,
  IconSearch,
  IconFilter,
  IconSettings,
  IconTools,
  IconHammer,
  IconPaint,
  IconPalette,
  IconPhoto,
  IconMovie,
  IconBrandNetflix,
  IconDeviceTv,
  IconRadio,
  IconCat,
  IconDog,
  IconFish,
  IconButterfly,
  IconBug,
  IconSpider,
  IconDeer,
  IconHorse,
  IconPig,
  IconEgg,
  IconFeather,
  IconPaw,
  IconApps,
  IconDeviceMobile,
  IconCards,
  IconVocabulary,
  IconAlbum,
  IconPlayerPlay,
  IconChess,
  IconDice,
  IconArticle,
  IconMoodSmile,
  IconUserCheck,
  IconBrowser,
  IconTool,
  IconScript,
  IconQuote,
  IconWriting,
  IconBrandWindows,
  IconBrandChrome,
  IconDeviceDesktop,
  IconUserPlus,
  IconBabyCarriage,
  IconUser,
  IconHistory,
  IconSparkles,
  IconMessageCircle,
  IconAbc,
  IconVolume,
  IconBallFootball,
  IconMapPins,
  IconCurrencyDollar,
  IconCurrencyDollarOff,
  IconRepeat,
  IconWifiOff,
  IconClick,
  IconCertificate,
  IconAward,
  IconBroadcast,
  type Icon,
  IconLibrary,
  IconRun,
} from "@tabler/icons-react"

/**
 * Mapping of server icon identifiers to Tabler icon components.
 * Server sends icon names like "clover", "flag_ireland", "book"
 * and we map them to the appropriate React icon component.
 */
export const ICON_MAP: Record<string, Icon> = {
  // Irish/Celtic themed
  clover: IconClover,
  shamrock: IconClover,
  flag: IconFlag,
  flag_ireland: IconFlag,
  celtic: IconClover,

  // Learning & Education
  book: IconBook,
  books: IconBooks,
  school: IconSchool,
  language: IconLanguage,
  pencil: IconPencil,

  // Media
  music: IconMusic,
  microphone: IconMicrophone,
  podcast: IconMicrophone,
  video: IconVideo,
  movie: IconMovie,
  tv: IconDeviceTv,
  radio: IconRadio,
  headphones: IconHeadphones,
  vinyl: IconVinyl,
  piano: IconPiano,
  spotify: IconBrandSpotify,
  youtube: IconBrandYoutube,
  netflix: IconBrandNetflix,

  // Games
  game: IconDeviceGamepad2,
  gamepad: IconDeviceGamepad2,

  // Places & Geography
  map: IconMap,
  map_pin: IconMapPin,
  location: IconMapPin,
  world: IconWorld,
  globe: IconGlobe,
  compass: IconCompass,
  anchor: IconAnchor,
  mountain: IconMountain,

  // Buildings
  home: IconHome,
  house: IconHome,
  building: IconBuilding,
  castle: IconTower,
  bank: IconBuildingBank,
  bridge: IconBuildingBridge,
  lighthouse: IconBuildingLighthouse,

  // Nature
  tree: IconTree,
  leaf: IconLeaf,
  plant: IconPlant,
  sun: IconSun,
  moon: IconMoon,
  cloud: IconCloud,
  droplet: IconDroplet,
  water: IconDroplet,
  flame: IconFlame,
  fire: IconFlame,

  // Social
  heart: IconHeart,
  star: IconStar,
  users: IconUsers,
  user: IconUser,
  community: IconUsers,
  calendar: IconCalendarEvent,
  event: IconCalendarEvent,

  // Content
  news: IconNews,
  article: IconNews,
  brush: IconBrush,
  paint: IconPaint,
  palette: IconPalette,
  camera: IconCamera,
  photo: IconPhoto,

  // Fantasy/Gaming
  crown: IconCrown,
  shield: IconShield,
  sword: IconSword,
  wand: IconWand,
  ghost: IconGhost,
  skull: IconSkull,
  diamond: IconDiamond,
  coins: IconCoins,
  trophy: IconTrophy,
  medal: IconMedal,

  // Science
  rocket: IconRocket,
  planet: IconPlanet,
  atom: IconAtom,
  dna: IconDna,
  flask: IconFlask,
  microscope: IconMicroscope,

  // Health
  stethoscope: IconStethoscope,
  pill: IconPill,
  medicine: IconPill,

  // Food & Drink
  apple: IconApple,
  coffee: IconCoffee,
  beer: IconBeer,
  glass: IconGlass,
  drink: IconGlass,
  chef: IconChefHat,
  cooking: IconChefHat,
  grill: IconGrill,

  // Transport
  car: IconCar,
  bike: IconBike,
  bicycle: IconBike,
  plane: IconPlane,
  ship: IconShip,
  boat: IconShip,
  train: IconTrain,
  bus: IconBus,

  // Tech
  apple_brand: IconBrandApple,
  android: IconBrandAndroid,
  settings: IconSettings,
  tools: IconTools,
  hammer: IconHammer,

  // Communication
  message: IconMessage,
  messages: IconMessages,
  chat: IconMessages,
  mail: IconMail,
  email: IconMail,
  bell: IconBell,
  notification: IconBell,

  // Status
  bulb: IconBulb,
  idea: IconBulb,
  question: IconQuestionMark,
  info: IconInfoCircle,
  alert: IconAlertCircle,
  warning: IconAlertCircle,
  success: IconCircleCheck,
  check: IconCircleCheck,
  error: IconCircleX,
  search: IconSearch,
  filter: IconFilter,

  // Animals
  cat: IconCat,
  dog: IconDog,
  fish: IconFish,
  butterfly: IconButterfly,
  bug: IconBug,
  spider: IconSpider,
  deer: IconDeer,
  horse: IconHorse,
  pig: IconPig,
  egg: IconEgg,
  feather: IconFeather,
  paw: IconPaw,

  // Resource Type Icons
  app: IconApps,
  apps: IconApps,
  mobile: IconDeviceMobile,
  course: IconSchool,
  flashcard: IconCards,
  flashcards: IconCards,
  dictionary: IconVocabulary,
  album: IconAlbum,
  audiobook: IconHeadphones,
  documentary: IconMovie,
  music_video: IconPlayerPlay,
  video_game: IconDeviceGamepad2,
  board_game: IconChess,
  dice: IconDice,
  publication: IconArticle,
  comic: IconMoodSmile,
  teacher: IconUserCheck,
  website: IconBrowser,
  tool: IconTool,
  codex: IconScript,
  interview: IconQuote,
  post: IconWriting,

  // Platform Icons
  ios: IconBrandApple,
  windows: IconBrandWindows,
  chrome: IconBrandChrome,
  desktop: IconDeviceDesktop,
  linux: IconDeviceDesktop,
  web: IconBrowser,

  // Level Icons
  beginner: IconUserPlus,
  intermediate: IconUser,
  advanced: IconUserCheck,
  native: IconUsers,
  children: IconBabyCarriage,
  adults: IconUser,

  // Content Category Icons
  history: IconHistory,
  mythology: IconSparkles,
  folklore: IconGhost,
  grammar: IconAbc,
  vocabulary: IconVocabulary,
  verb: IconRun,
  run: IconRun,
  running: IconRun,
  pronunciation: IconVolume,
  conversation: IconMessageCircle,
  literature: IconLibrary,
  poetry: IconPencil,
  traditional_music: IconMusic,
  sean_nos: IconMusic,
  nua_nos: IconMusic,
  current_affairs: IconNews,
  sports: IconBallFootball,
  gaa: IconBallFootball,
  travel: IconPlane,
  food: IconChefHat,
  nature: IconLeaf,
  science: IconFlask,
  script: IconScript,

  // Location Icons
  gaeltacht: IconMapPins,
  dublin: IconBuilding,
  galway: IconMapPin,
  cork: IconMapPin,
  belfast: IconMapPin,
  donegal: IconMapPin,
  kerry: IconMapPin,
  connemara: IconMountain,

  // Feature Icons
  free: IconCurrencyDollarOff,
  paid: IconCurrencyDollar,
  subscription: IconRepeat,
  offline: IconWifiOff,
  interactive: IconClick,
  spaced_repetition: IconRepeat,
  immersive: IconHeadphones,

  // Certification Icons
  teg: IconCertificate,
  leaving_cert: IconAward,
  cefr: IconCertificate,

  // Organization Icons
  rte: IconBroadcast,
  tg4: IconDeviceTv,
  foras_na_gaeilge: IconClover,
  conradh_na_gaeilge: IconClover,
  gael_linn: IconClover,
  bbc: IconBroadcast,

  // Language Icons
  irish_language: IconClover,
  celtic_languages: IconClover,
  scottish_gaelic: IconFlag,
  welsh: IconFlag,
  breton: IconFlag,
  manx: IconFlag,
  cornish: IconFlag,

  // Dialect Icons
  connacht_irish: IconMapPin,
  munster_irish: IconMapPin,
  ulster_irish: IconMapPin,
}

export interface ServerResourceIconProps {
  /** The icon identifier from the server (e.g., "clover", "flag_ireland") */
  icon?: string | null
  /** Icon size in pixels */
  size?: number
  /** Additional CSS classes */
  className?: string
  /** Stroke width for the icon */
  stroke?: number
  /** Fallback icon to use if the specified icon is not found */
  fallback?: Icon
  /** Inline styles */
  style?: React.CSSProperties
}

/**
 * Renders an icon based on a server-provided identifier.
 * Maps icon names like "clover", "flag_ireland" to Tabler icon components.
 */
export const ServerResourceIcon: React.FC<ServerResourceIconProps> = ({
  icon,
  size = 24,
  className,
  stroke = 2,
  fallback,
  style,
}) => {
  if (!icon) {
    if (fallback) {
      const FallbackIcon = fallback
      return (
        <FallbackIcon
          size={size}
          className={className}
          stroke={stroke}
          style={style}
        />
      )
    }
    return null
  }

  // Normalize the icon name (lowercase, replace hyphens with underscores)
  const normalizedIcon = icon.toLowerCase().replace(/-/g, "_")
  const IconComponent = ICON_MAP[normalizedIcon]

  if (!IconComponent) {
    if (fallback) {
      const FallbackIcon = fallback
      return (
        <FallbackIcon
          size={size}
          className={className}
          stroke={stroke}
          style={style}
        />
      )
    }
    return null
  }

  return (
    <IconComponent
      size={size}
      className={className}
      stroke={stroke}
      style={style}
    />
  )
}

/**
 * Get the icon component for a given server icon identifier.
 * Returns undefined if the icon is not found.
 */
export const getIconComponent = (icon?: string | null): Icon | undefined => {
  if (!icon) return undefined
  const normalizedIcon = icon.toLowerCase().replace(/-/g, "_")
  return ICON_MAP[normalizedIcon]
}

/**
 * Check if an icon identifier has a corresponding component.
 */
export const hasIcon = (icon?: string | null): boolean => {
  if (!icon) return false
  const normalizedIcon = icon.toLowerCase().replace(/-/g, "_")
  return normalizedIcon in ICON_MAP
}

export default ServerResourceIcon
